/**
 * Validates the mutation state for creating or updating a request and returns an object
 * containing errors, if any.
 *
 * @param {object} state - The state object representing the mutation data.
 * @param {string} state.title - The title of the request.
 * @param {string} state.dueDate - The due date of the request.
 * @param {Array} state.requiredDocs - An array of required documents for the request.
 * @param {object} state.requiredDocs[].documentName - The name of the document.
 * @param {Array} state.users - An array of users associated with the request.
 * @param {object} state.currentSelectTemplate - The selected template for the request.
 * @param {string} state.currentSelectTemplate.title - The title of the selected template.
 * @param {object} state.currentSelectMailingList - The selected mailing list for the request.
 * @param {string} state.currentSelectMailingList.title - The title of the selected mailing list.
 *
 * @returns {object} An object containing errors, if any, for the mutation state.
 */
export function validateRequestMutationState(state) {
  const errors = {};

  // 1. Title can not be empty
  if (!state.title.trim()) {
    errors.title = "Title cannot be empty";
  }

  // 2. dueDate can not be empty
  if (!state.dueDate.trim()) {
    errors.dueDate = "Due date cannot be empty";
  }

  // 3. requiredDocs should have at least one element, and every element should have a non-empty documentName
  if (
    state.requiredDocs.length === 0 ||
    !state.requiredDocs.every((doc) => doc.documentName.trim())
  ) {
    errors.requiredDocs =
      "There should be at least one required document, and every document should have a non-empty documentName";
  }

  // 4. users length should be at least one
  if (state.users.length === 0) {
    errors.users = "At least one user is required";
  }

  return errors;
}
